/**
 * Explicit call-session state for placement and lifecycle flags that were previously
 * scattered across boolean refs (easier to reason about and reset in one place).
 *
 * Placement flow: idle → (PLACEMENT_START) → busy → (PLACEMENT_END) → idle or succeeded.
 * Guards duplicate auto-dial: outgoingPlaceSucceeded, hasObservedActiveCall, placeAttempts.
 */

export const initialCallSessionState = {
  /** True while placeCall is in flight */
  placementBusy: false,
  /** Incremented at each placeCall attempt (max 2, matching previous behavior) */
  placeAttempts: 0,
  /** At least one placeCall completed successfully this route */
  outgoingPlaceSucceeded: false,
  /** SDK reported connected / live media */
  hasConnected: false,
  hadLiveCall: false,
  /** Hangup or provider teardown observed; coordinates summary/billing race */
  callJustEnded: false,
  /** Any activeCall was seen this route (skip duplicate place after refresh) */
  hasObservedActiveCall: false,
};

export function callSessionReducer(state, action) {
  switch (action.type) {
    case 'RESET':
      return { ...initialCallSessionState };

    case 'PLACEMENT_START':
      if (state.placeAttempts >= 2 || state.placementBusy) return state;
      return {
        ...state,
        placementBusy: true,
        placeAttempts: state.placeAttempts + 1,
      };

    case 'PLACEMENT_END': {
      const { ok } = action;
      return {
        ...state,
        placementBusy: false,
        outgoingPlaceSucceeded: state.outgoingPlaceSucceeded || Boolean(ok),
      };
    }

    case 'OBSERVE_ACTIVE_CALL':
      return { ...state, hasObservedActiveCall: true };

    case 'SESSION_CONNECTED':
      return {
        ...state,
        hasConnected: true,
        hadLiveCall: true,
      };

    case 'CALL_JUST_ENDED':
      return { ...state, callJustEnded: true };

    case 'CLEAR_CALL_JUST_ENDED':
      return { ...state, callJustEnded: false };

    default:
      return state;
  }
}
